import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DishesService} from "app/services/dishes.service";
import {TranslateService} from "@ngx-translate/core";
import {DomSanitizer} from "@angular/platform-browser";
import {UploadVideoRequest} from "app/models/menu.model";
import {take} from "rxjs";

@Component({
  selector: 'app-select-video-field',
  templateUrl: './select-video-field.component.html',
  styleUrls: ['./select-video-field.component.scss']
})
export class SelectVideoFieldComponent implements OnInit {
  reader = new FileReader();
  mediaDefaultSrc = '';
  selectedMediaSrc;

  @Input() allowOverrides: boolean;
  @Input() video: string;
  @Input() organizationId: string;
  @Input() overrideUrl: string;
  @Input() inputVideoDefaultSrc: string;
  @Output() videoChanged = new EventEmitter<string>();

  constructor(
    private dishesService: DishesService,
    private translate: TranslateService,
    private sanitizer: DomSanitizer
  ) {
  }

  ngOnInit(): void {
    this.mediaDefaultSrc = this.inputVideoDefaultSrc ?? this.mediaDefaultSrc;
    this.selectedMediaSrc = this.video ? this.video : this.mediaDefaultSrc;
    this.reader.onload = (e: any) => {
      const base64String = e.target.result
        .replace('data:', '')
        .replace(/^.+,/, '');
      const format = this.getMediaTypeFromBase64(e.target.result);

      const uploadVideoRequest: UploadVideoRequest = {
        organizationId: this.organizationId,
        videoBase64: base64String,
        IsDeletedPicture: false,
        format: format,
      };

      if (this.overrideUrl) {
        uploadVideoRequest.videoUrl = this.overrideUrl;
      }

      this.dishesService.uploadVideo$(uploadVideoRequest)
        .pipe(take(1))
        .subscribe(res => {
          const videoUrl = res.data;
          this.selectedMediaSrc = videoUrl;
          this.videoChanged.emit(videoUrl);
        });
    };
  }

  changeVideo(event): void {
    if (!this.allowOverrides) {
      return;
    }
    if (event.target.files && event.target.files[ 0 ]) {
      this.reader.readAsDataURL(event.target.files[ 0 ]);
    }
  }

  deleteDishVideo(): void {
    if (!this.allowOverrides) {
      return;
    }
    this.selectedMediaSrc = this.mediaDefaultSrc;
    this.videoChanged.emit('');
  }

  getMediaTypeFromBase64(base64String) {
    if (!base64String) {
      return null;
    }
    const pattern = 'data:(image|video)/([a-zA-Z0-9]+)';
    const regexp = new RegExp(pattern);
    const match = base64String.match(regexp);
    if (match && match.length >= 3) {
      return match[ 2 ];
    } else {
      alert(this.translate.instant('MENU.ALERT_MEDIA'));
      return null;
    }
  }

  isVideo(format: string): boolean {

    switch (format) {
      case 'mp4':
        return true;
      case 'jpeg':
      case 'jpg':
      case 'png':
        return false;
      case null:
        return null;
    }
  }

  getMediaTypeByUrl(url: string) {
    if (!url || typeof url !== 'string') {
      return null;
    }
    return url.substring(url.lastIndexOf('.') + 1);
  }
}
